import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './App.css';
import './components/General/AdminListCard.css';
import './styles/filter-panels.css';
import './template/mini-sidebar/scss/style.scss';
import './styles/app-toast-theme.css';
import 'bootstrap/dist/css/bootstrap.css';

const rootEl = document.getElementById('root');
const root = createRoot(rootEl);
root.render(<App />);

serviceWorker.register();